<template>
  <div>
    <div v-if="Lib.checkPower('beauty-4-ckcpxsfx',2)" class="saleProduct">
      <date-picker @selectDate="initetProductAnalyseMsg" />
      <div class="bar-box">
        <div class="saleProduct-font">
          产品销售趋势
        </div>
        <div id="barDate" style="width:1600px;height:300px;margin:0 auto"></div>
      </div>
      <!--图-->
      <div class="pie-box">
        <div class="pie-item">
          <h1 class="saleProject-font">产品销售量统计（不同终端）</h1>
          <h2>
            总销售量：{{ list.appSaleCount + list.pcSaleCount }}
            <el-tooltip class="item" effect="light" :content="'所选时间段内的产品总销售量统计，不包含退款产品'" placement="right">
              <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
            </el-tooltip>
          </h2>
          <div id="barDateTow" :style="{width: '500px', height: '180px'}"></div>
        </div>
        <div class="pie-item">
          <h1 class="saleProject-font">产品销售量排行</h1>
          <h2>
            总销售量：{{ list.appSaleCount + list.pcSaleCount }}
            <el-tooltip class="item" effect="light" :content="'所选时间段内的产品总销售量统计，不包含退款产品'" placement="right">
              <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;margin:0 auto"></i>
            </el-tooltip>
          </h2>
          <div id="pieDate" style="width:700px;height:320px;top: -27px;}"></div>
        <!-- <gt-noneData :show-border="true" :title="'暂无数据'" style="margin:20px 0px;"></gt-noneData> -->
        </div>
      </div>
      <!--表格-->
      <div class="saleProject-table">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="增长明细" name="first">
            <el-table tooltip-effect="light" :data="tableData" style="width: 100%">
              <el-table-column type="index" width="100" label="排名">
                <template slot-scope="scope">
                  {{ scope.$index*1+1 + (currentPage*1-1)*10 }}
                </template>
              </el-table-column>
              <el-table-column prop="productName" label="产品名称"></el-table-column>
              <el-table-column prop="saleCount" label="产品销售量"></el-table-column>
              <el-table-column prop="salePercentage" label="销售量占比" sortable>
                <template slot-scope="scope">
                  {{ scope.row.salePercentage }}%
                </template>
              </el-table-column>
              <el-table-column prop="yearGrowthPercentage" sortable>
                <template slot="header" slot-scope="scope">
                  同比增长率
                  <el-tooltip v-show="scope" effect="light" :content="'对比本期与去年同期，该产品的同比增长率'" placement="right">
                    <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <span :class="scope.row.yearGrowthPercentage==0?'sale-color':scope.row.yearGrowthPercentage>0?'sale-color-green':'sale-color-red'"> {{ scope.row.yearGrowthPercentage }}%</span>
                </template>
              </el-table-column>
              <el-table-column prop="chainGrowthPercentage" sortable>
                <template slot="header" slot-scope="scope">
                  环比增长率
                  <el-tooltip v-show="scope" effect="light" :content="'对比本期与上期，该产品的环比增长率'" placement="right">
                    <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <span :class="scope.row.chainGrowthPercentage==0?'sale-color':scope.row.chainGrowthPercentage>0?'sale-color-green':'sale-color-red'"> {{ scope.row.chainGrowthPercentage }}%</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination v-if="tableData.length!=0" background layout="prev, pager, next" :current-page.sync="currentPage" :total="total" @current-change="handleCurrentChange"></el-pagination>
          </el-tab-pane>
        </el-tabs>
        <div class="button_group">
          <el-button size="small" @click="onExportTable">导出报表</el-button>
          <el-button size="small" @click="onPrint">打印报表</el-button>
        </div>
      </div>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>
<script>
// import echarts from 'echarts';
import * as echarts from 'echarts';
import api from '../api/index';
import { echartsA } from '../echarts/echartsA';
import { echartsB } from '../echarts/echartsB';
import { echartsC } from '../echarts/echartsC';

export default {
  data() {
    return {
      list: {
        productSaleTrendList: [],
        productSaleRankList: [],
      },
      activeName: 'first',
      tableData: [],
      currentPage: 1,
      total: 0,
      myChartA: '',
      myChartB: '',
      myChartC: '',
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 获取数据
    initetProductAnalyseMsg(e) {
      // 基于准备好的dom，初始化echarts实例
      this.myChartA = echarts.init(document.getElementById('barDate'));
      this.myChartB = echarts.init(document.getElementById('barDateTow'));
      this.myChartC = echarts.init(document.getElementById('pieDate'));
      // 加载中
      const style = {
        text: '', // 加载时候的文本
      };
      this.myChartA.showLoading(style);
      this.myChartB.showLoading(style);
      this.myChartC.showLoading(style);

      // 获取数据
      const data = {
        beginTime: e.beginTime,
        endTime: e.endTime,
        dateType: e.dateType,
        mainId: sessionStorage.getItem('mainId'),
      };
      // console.log('data', data);
      api.getProductAnalyseMsg(data).then((res) => {
        if (res.code === 0) {
          this.list = res.data;
          this.tableData = res.data.productSaleRiseList;
          this.total = Object.keys(res.data.productSaleRiseList).length;
          this.handleCurrentChange(1);
          this.drawProjectBar(res.data.productSaleTrendList);
          this.drawProjectBarTow(res.data);
          this.drawProjectPie(res.data.productSaleRankList);
          // 关闭加载
          this.myChartA.hideLoading();
          this.myChartB.hideLoading();
          this.myChartC.hideLoading();
        }
      });
    },
    // 创建产品销售趋势柱状图
    drawProjectBar(data) {
      // 基于准备好的dom，初始化echarts实例
      // const myChart = echarts.init(document.getElementById('barDate'));
      // 监听屏幕变化自动缩放图表
      window.addEventListener('resize', () => { this.myChartA.resize(); });
      // 使用刚指定的配置项和数据显示图表。
      const option = echartsA(data);
      this.myChartA.setOption(option);
    },

    // 创建产品销售量统计柱状图
    drawProjectBarTow(data) {
      // const myChart = echarts.init(document.getElementById('barDateTow'));
      window.addEventListener('resize', () => { this.myChartB.resize(); });
      const option = echartsB(data, 2);
      this.myChartB.setOption(option);
    },

    // 创建产品销售量排行饼图
    drawProjectPie(data) {
      // const myChart = echarts.init(document.getElementById('pieDate'));
      window.addEventListener('resize', () => { this.myChartC.resize(); });
      const option = echartsC(data, 2);
      this.myChartC.setOption(option);
    },
    // 导出报表
    onExportTable() {
      if (this.Lib.checkPower('beauty-4-dccpxsfx') == false) return;
      const item = JSON.parse(window.sessionStorage.getItem('selectDate'));
      this.$root.$children[0].fatherExport('exportProductSaleRiseList', item.beginTime, item.endTime, item.dateType);
    },
    // 打印报表
    onPrint() {
      if (this.Lib.checkPower('beauty-4-dycpxsfx') == false) return;
      this.$print({
        data: this.tableData,
        table_tol: [
          {
            prop: 'productName',
            name: '产品名称'
          },
          {
            prop: 'saleCount',
            name: '产品销售量'
          },
          {
            prop: 'salePercentage',
            name: '销售量占比'
          },
          {
            prop: 'yearGrowthPercentage',
            name: '同比增长率'
          },

          {
            prop: 'chainGrowthPercentage',
            name: '环比增长率'
          },
        ],
        title: '增长明细'
      });
    },
    // 分页数据处理函数
    handleCurrentChange(val) {
      // 处于第几页 val
      // 保存每页数据的函数
      const tableData = [];
      // pagesize=10 每页条数
      // 设置开始
      const start = 10 * val - 10;
      // 设置结束长度
      let end = 10 * val; // 长度判断 //所有分页数据 this.tableData
      end = end > this.list.productSaleRiseList.length ? this.list.productSaleRiseList.length : end;
      for (let i = start; i < end; i++) {
        // 所有分页数据 this.tableData
        tableData.push(this.list.productSaleRiseList[i]);
      }
      this.tableData = tableData;
    },
  },

};
</script>

<style lang="less" scoped>
.sale-color-green{
  color:#06EB00;
}
.sale-color-red{
   color:#f56c6c;
}
.sale-color{
  color: #343232;
}
.saleProduct{
  max-width: 1700px;
  width: 100%;
  .bar-box{
    // width: 100%;
    height:327px;
    padding: 30px;
    border: solid 1px #ebeef5;
    margin: 20px 0;
    overflow: auto;
  }
  .pie-box{
     display: flex;
     flex-direction: row;
     justify-content: space-between;
     align-items: center;
     margin-bottom: 20px;
     overflow: auto;
    .pie-item{
      // flex:1;
      // height: 440px;
      // background-color: #ffffff;
      // border: solid 1px #ebeef5;
      // margin-right:20px;
      // padding: 30px;
        // height: 440px;
      // background-color: #ffffff;
      // border: solid 1px #ebeef5;
      // margin-right:20px;
      // padding: 30px;
       height: 420px;
          min-width: 780px;
    // height: 336px;
    background-color: #ffffff;
    border: solid 1px #ebeef5;
    display: inline-block;
    padding: 30px;
    margin-top: 20px;
      h2{
        font-size: 14px;
        color: #2d2f33;
        margin:38px 0 47px 0;
      }
    }
    .pie-item:last-child{
       margin-left:20px;
    }
  }
  .saleProject-font{
    font-size: 14px;
    color: #2d2f33;
    font-weight: 900;
  }
  .saleProject-table{
    position: relative;
    .button_group {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>
